import { createSelector } from '@reduxjs/toolkit';

import { selectAvailableBalance } from 'redux/slices/account';
import { selectNearTokenFiatValueUSD } from 'redux/slices/tokenFiatValues';

export default createSelector(
  [selectAvailableBalance, selectNearTokenFiatValueUSD],
  (balanceAvailable, usd) => ({
    balance: balanceAvailable || '',
    contractName: undefined,
    onChainFTMetadata: { symbol: 'NEAR', decimals: 24 },
    fiatValueMetadata: { usd }
  })
);
